<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>语言配置</span>

          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importLangCfg(res)}"
                :headers="headers"
              >
                <el-button v-permisaction="['config:langCfg:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:langCfg:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData()"
              >导出</el-button>
            </el-col>
          </el-row>
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="语言KEY">
              <el-input v-model="item.key" style="width: 350px;" placeholder="语言KEY" />
            </el-form-item>
            <el-form-item label="语言值">
              <el-input v-model="item.content" style="width: 500px;" placeholder="语言值" />
            </el-form-item>
            <el-form-item>
              <el-button v-if="formManyData.hasOwnProperty(item.key)" type="text" @click="dialogVisible[index].visible=true">配置多语言</el-button>
              <div v-if="formManyData.hasOwnProperty(item.key)">
                <el-drawer
                  title="配置多语言"
                  :visible.sync="dialogVisible[index].visible"
                  size="700px"
                  :before-close="(v)=>{return handleClose(v, index)}"
                  @open="openManyLang(item.key)"
                >
                  <el-form :inline="true">
                    <el-row v-for="(l, i) in formManyData[item.key]" :key="i">
                      <el-form-item :label="lang[l.lang]" style="margin-top: 10px;">
                        <el-input v-model="l.content" style="width: 500px;" placeholder="语言值" />
                      </el-form-item>
                    </el-row>
                  </el-form>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible[index].visible= false">取 消</el-button>
                    <el-button type="primary" @click="manyOnSubmit(index, item.key)">确 定</el-button>
                  </span>
                </el-drawer>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:langCfg:del']" type="danger" @click="del(item.key)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:langCfg:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-permisaction="['config:langCfg:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import {
  delLangCfg,
  exportLangCfg,
  getLangCfg,
  getLangCfgList,
  updateLangCfg,
  importLangCfg
} from '@/api/config/lang-cfg'
import { getToken } from '@/utils/auth'
export default {
  name: 'LangConfig',
  data() {
    return {
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      dialogVisible: [{ visible: false }],
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        lang: 'LZH'
      },
      lang: {
        'LEN': '英 文',
        'LZH': '中 文',
        'LTW': '繁 体',
        'LFR': '法 语',
        'LDE': '德 语',
        'LES': '西班牙',
        'LPT': '葡萄牙',
        'LTH': '泰 语',
        'LVN': '越 南',
        'LNO': '挪 威',
        'LID': '印 尼'
      },
      formData: [
        {
          'lang': '',
          'key': '',
          'content': ''
        }
      ],
      formManyData: [
        {
          'lang': '',
          'key': '',
          'content': ''
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit(formManay = []) {
      console.log(formManay)
      let data = []
      if (formManay.length) {
        data = JSON.stringify(formManay)
      } else {
        data = JSON.stringify(this.formData)
      }

      if (data.length <= 0) {
        this.msgError('没有要提交的数据')
        return
      }
      console.log('onSubmit', data)
      updateLangCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getLangCfgList(this.queryParams).then(res => {
        if (res.code === 200) {
          res.data.list.forEach(item => {
            this.$set(this.formManyData, item.key, [])
            for (const l in this.lang) {
              this.formManyData[item.key].push({
                'lang': l,
                'key': item.key,
                'content': ''
              })
            }
            this.dialogVisible.push({ visible: false })
          })
          this.formData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(done, index) {
      this.dialogVisible[index].visible = false
    },
    add() {
      this.formData.push({
        'lang': 'LZH',
        'key': '',
        'content': ''
      })
      this.dialogVisible.push({ visible: false })
    },
    openManyLang(name) {
      getLangCfg({ name: name }).then(res => {
        if (res.code === 200) {
          const _data = this.formManyData[name]
          console.log('_data', _data)
          console.log(_data)
          if (res.data.length) {
            res.data.forEach(item => {
              for (const i in _data) {
                if (_data[i].lang === item.lang) {
                  _data[i].content = item.content
                }
              }
            })

            this.formManyData[name] = _data
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    manyOnSubmit(index, name) {
      this.dialogVisible[index].visible = false
      this.onSubmit(this.formManyData[name])
    },
    del(name) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delLangCfg({ name: name }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    }, exportData() {
      exportLangCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importLangCfg(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importLangCfg({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
